// extracted by mini-css-extract-plugin
module.exports = {"container-A":"privatePolicy_container-A__3tzJ3","container":"privatePolicy_container__1YKXb","title":"privatePolicy_title__2n2i-","content":"privatePolicy_content__2f-3k"};